import api from "../../../settings/api";
import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, PutEffect } from "redux-saga/effects";

export interface Fetch {
    requestId: string;
    callback: (success: boolean, code?: string) => void;
}

export interface DebtsPullingAction {
    type: string;
    payload: Fetch;
}

export default function* debtsPulling({
    payload,
}: DebtsPullingAction): Generator<
    CallEffect<unknown> | PutEffect<Action>,
    void,
    AxiosResponse
> {
    try {
        const response = yield call(api.get, `/v1/vehicle-debts/status/${payload.requestId}`);

        if (response?.data?.data?.flSituacao === 2) {
            yield call(payload.callback, true, response?.data?.data?.passagens);
        } else {
            yield call(payload.callback, false, response?.data?.data?.flSituacao === 3 ? "timeout" : "again");
        }

    } catch (error) {
        yield call(payload.callback, false, "timeout");
    }
}